export enum XK852Power {
  Off = 'Off',
  RxOnly = 'Receive Only',
  Low = 'Low Power',
  Mid = 'Medium Power',
  Full = 'Full Power'
}

export enum XK852Mode {
  AME = 'AME',
  USB = 'USB',
  LSB = 'LSB',
  CW  = 'CW',
  ISB = 'ISB',
  FSK_LP = 'FSK Low Power',
  FSK_MID = 'FSK Medium Power',
  FSK_HP = 'FSK High Power'
}
